export default __webpack_public_path__ + "static/media/brian.c5262b8b.jpeg";